import { UserRole } from '../types/users';
import { PRIVATE_PATHS } from './constants';

export const getDefaultRouteByRole = (roles: UserRole[], orgSlug: string): string => {
  if (!roles || roles.length === 0) return PRIVATE_PATHS.PMO.PROJECTS.replace(':orgSlug', orgSlug);

  // Check ORG roles or HRMS roles first because HRMS takes precedence over PMO
  if (
    roles.includes('ORG_OWNER') || 
    roles.includes('ORG_ADMIN') ||
    roles.includes('HRM_ADMIN') || 
    roles.includes('HRM_MANAGER') || 
    roles.includes('HRM_EMPLOYEE') ||
    roles.includes('EMPLOYEE')
  ) {
    return PRIVATE_PATHS.HRMS.DASHBOARD.replace(':orgSlug', orgSlug);
  }

  if (
    roles.includes('PMO_ADMIN') ||
    roles.includes('PMO_MANAGER') ||
    roles.includes('PMO_USER')
  ) {
    return PRIVATE_PATHS.PMO.PROJECTS.replace(':orgSlug', orgSlug);
  }

  if (
    roles.includes('CRM_ADMIN') ||
    roles.includes('CRM_MANAGER') ||
    roles.includes('CRM_USER')
  ) {
    return PRIVATE_PATHS.CRM.CONTACTS.VIEW_ALL.replace(':orgSlug', orgSlug);
  }

  // Fallback for EMPLOYEE, NONE
  return PRIVATE_PATHS.CORE.DASHBOARD.replace(':orgSlug', orgSlug);
};
